import { render, staticRenderFns } from "./EditSOS.vue?vue&type=template&id=b579949c&scoped=true"
import script from "./EditSOS.vue?vue&type=script&lang=js"
export * from "./EditSOS.vue?vue&type=script&lang=js"
import style0 from "./EditSOS.vue?vue&type=style&index=0&id=b579949c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b579949c",
  null
  
)

export default component.exports